import { TFunction } from 'i18next';

import { ErrContextInterface } from '../../containers/aio/PaymentMethodsContainer/context';

export function setContextError(
    ctx: ErrContextInterface,
    error: any, // eslint-disable-line @typescript-eslint/no-explicit-any
    t: TFunction<'error', undefined>,
) {
    let errorMessage = t('defaultPaymentError.message');
    if (error?.message) {
        try {
            const messageError = JSON.parse(error.message);
            if (messageError.code === 'errRiskyGiftCard') {
                errorMessage = t('errRiskyGiftCard.message');
            }
        } catch (error) {
            errorMessage = t('defaultPaymentError.message');
        }
    }
    ctx.setError(errorMessage);
}
